export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-b1097db5e20e6a942e400b76194f3701.svg";